var _style, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 320 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .small {\n      font: italic 13px sans-serif;\n    }\n    .heavy {\n      font: bold 30px sans-serif;\n    }\n\n    /* Note that the color of the text is set with the    *\n     * fill property, the color property is for HTML only */\n    .Rrrrr {\n      font: italic 40px serif;\n      fill: teal;\n    }\n  ")), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 65,
    y: 55,
    className: "Rrrrr"
  }, "ProSoftTools")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.04e87e5b29cedc16b6525c5003aee131.svg";
export { ForwardRef as ReactComponent };